// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-product__total{color:#fff;font-size:12px;display:flex;align-items:center;padding:16px 0 14px}.plv-iar-product__total span{color:#f15d5d;margin-left:3px;margin-right:3px}.plv-iar-product-label-list+.plv-iar-product__total{padding-top:4px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
